export default __webpack_public_path__ + "static/media/Logo_symbol-yellow.f3b48204.png";